import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";

import {WorkerKey} from "./WorkerKey";
import {Schema} from "@/common/Schema";


export class WorkerConfig extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(WorkerConfig, v) : SKIP;
            },
            (v) => {
                return deserialize(WorkerConfig, v);
            }
        );
    }

    constructor() {
        super();
        this._worker = null;
        this._capacity = 1;

        this._lifeTime = 0
        this._rushTime = 0;
        this._sleepTime = 0;

        this._public = false;
        this._shared = false;
    }

    get worker() {
        return this._worker;
    }

    set worker(value) {
        this._worker = value;
    }

    get capacity() {
        return this._capacity;
    }

    set capacity(value) {
        this._capacity = value;
    }

    get lifeTime() {
        return this._lifeTime;
    }

    set lifeTime(value) {
        this._lifeTime = value;
    }

    get rushTime() {
        return this._rushTime;
    }

    set rushTime(value) {
        this._rushTime = value;
    }

    get sleepTime() {
        return this._sleepTime;
    }

    set sleepTime(value) {
        this._sleepTime = value;
    }

    get public() {
        return this._public;
    }

    set public(value) {
        this._public = value;
    }

    get shared() {
        return this._shared;
    }

    set shared(value) {
        this._shared = value;
    }

    valid() {

        if (!this.worker || !this.worker.valid() || this.worker.isNone()) {
            return false;
        }

        if (!Number.isInteger(this.capacity) || this.capacity <= 0) {
            return false;
        }

        if (!Number.isInteger(this.lifeTime) || this.lifeTime < 0) {
            return false;
        }

        if (!Number.isInteger(this.rushTime) || this.rushTime < 0) {
            return false;
        }

        if (!Number.isInteger(this.sleepTime) || this.sleepTime < 0) {
            return false;
        }

        return true;
    }

    empty() {
        return !this.worker || this.worker.isNone();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new WorkerConfig());
        } else if (target instanceof WorkerConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(WorkerConfig, {
    _worker: alias("worker", WorkerKey.schema()),
    _capacity: alias("capacity", Schema.primitive()),

    _lifeTime: alias("lifetime", Schema.primitive()),
    _rushTime: alias("rushtime", Schema.primitive()),
    _sleepTime: alias("sleep", Schema.primitive()),

    _public: alias("public", Schema.primitive()),
    _shared: alias("shared", Schema.primitive())
});